import SettingsIcon from '@mui/icons-material/Settings';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import { PAGES_URLS } from '../../../../lib/constants/routes';

function EInstellung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<SettingsIcon />} title={'Einstellungen'}>
				<MeinBereichButton buttonName='Mein Profil verwalten' onClick={() => navigate(PAGES_URLS.MeinProfil)} />
				<MeinBereichButton
					buttonName='Organisationsprofil verwalten'
					onClick={() => navigate(`${PAGES_URLS.MeinProfil}?activeSideBarButton=organisation`)}
				/>
				<MeinBereichButton
					buttonName='Zugangsdaten / Passwort verwalten'
					onClick={() => navigate(`${PAGES_URLS.MeinProfil}?activeSideBarButton=zugangsdaten`)}
				/>
			</MeinBereichPaper>
		</>
	);
}

export default EInstellung;
